module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"User Profile"},"de":{"siteTitle":"Benutzerprofil"},"fr":{"siteTitle":"Profil de l\u0027utilisateur"},"it":{"siteTitle":"Profilo utente"}}')
  delete Component.options._Ctor
}
